// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__LpsAy","input":"Input_input__nuJyQ","inputS":"Input_inputS__ERyb+","label":"Input_label__5hRry"};